import {
  connectorStatusVariant,
  formatConnectorLabel,
  sessionStatusVariant,
  translateDeviceStatus,
  translateInvitationStatus,
  translateSessionStatus,
  useTranslation,
} from '@eon/i18n';
import { Badge, StatusPill } from '@eon/ui';
import type { DeviceStatus } from '@eon/types';

export function DeviceStatusBadge({ status }: { status: DeviceStatus | string }) {
  const { t } = useTranslation();
  const normalized = String(status) as DeviceStatus;
  return (
    <StatusPill status={normalized} label={translateDeviceStatus(t, String(status))} />
  );
}

export function ConnectorStatusBadge({
  id,
  status,
  className,
}: {
  id: number;
  status: string;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <Badge variant={connectorStatusVariant(status)} className={className}>
      {formatConnectorLabel(t, id, status)}
    </Badge>
  );
}

export function SessionStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  return (
    <Badge variant={sessionStatusVariant(status)}>
      {translateSessionStatus(t, status)}
    </Badge>
  );
}

export function InvitationStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  return (
    <Badge variant="secondary">{translateInvitationStatus(t, status)}</Badge>
  );
}
